import { memo } from "react";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";
import useCouponCode from "../../../../hooks/useCouponCode";
import useDateTimer from "../../../../hooks/useDateTimer";

const DateCounter = memo(() => {
  // Updates current date every second.
  const currentDate = useDateTimer();
  
  const { getTextByKey } = useContent();
  const { couponCode } = useCouponCode();

  //display the time remaining for the coupon in structure like dd:hh:mm:ss
  const diff =
    (new Date(couponCode?.expireDate!) as unknown as number) -
    (currentDate as unknown as number);
  //if the different is more than 48 hours, return null
  if (diff > 1728000000) {
    return null;
  }
  const days = Math.floor(diff / 1000 / 60 / 60 / 24);
  const hours = Math.floor(diff / 1000 / 60 / 60) % 24;
  const minutes = Math.floor(diff / 1000 / 60) % 60;
  const seconds = Math.floor(diff / 1000) % 60;

  return (
    <div className="coupon-time-remaining">
      {getTextByKey("coupon-time-remaining")}
      {": "}
      {days > 0 && <span>{days > 9 ? days : "0" + days}</span>}
      {hours >= 0 && (
        <span>
          {days > 0 && ":"}
          {hours > 9 ? hours : "0" + hours}
        </span>
      )}
      {minutes >= 0 && (
        <span>
          {hours >= 0 && ":"}
          {minutes > 9 ? minutes : "0" + minutes}
        </span>
      )}
      {seconds >= 0 && (
        <span>
          {minutes >= 0 && ":"}
          {seconds > 9 ? seconds : "0" + seconds}
        </span>
      )}
    </div>
  );
});

export default DateCounter;
